/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import {
  DataType,
  DataTableColumn,
  DataTable,
  DataTableOptions,
  RowCustomAction,
  UserPermission
} from '@globaleris/ui.library'
import { useTranslation } from 'react-i18next'
import { useFormDialog, useConfirmationDialog } from '../../../../hooks'
import { Delete, Edit, Pageview } from '@material-ui/icons'
import { NewPosicionPrecio } from '../../../../api'
import { getUserPermissions, hasPermission } from '../../../../helpers/permissionsHelper'
import { Pages, Resources } from '../../../../model/RBAC/constants'

export interface TradePositionTableProps {
  setShowAddPosition: (show: boolean) => void
  tableData: NewPosicionPrecio[]
  canEdit: boolean
  // Add.tsx uses NewPosicionPrecio since the position is not created already (has no id).
  onEditPosition?: (position: NewPosicionPrecio) => void
  readOnly?: boolean
}

export const TradePositionTable = React.memo(
  ({
    setShowAddPosition,
    tableData,
    canEdit,
    onEditPosition,
    readOnly
  }: TradePositionTableProps) => {
    const { formProps, CustomFormDialog } = useFormDialog()
    const [t] = useTranslation([
      'pricing',
      'pricingDetails',
      'pricingAdd',
      'globalerisLibrary',
      'trades',
      'enums'
    ])

    const getTableActions = (): RowCustomAction[] | undefined => {
      let defaultActions = [
        {
          icon: <Pageview fontSize="small" />,
          tooltip: t('trades:positionTable.mainActions.viewDetails'),
          onClick: (position: NewPosicionPrecio) => {
            return onEditPosition && onEditPosition(position)
          }
        }
      ]

      return defaultActions
    }

    const tableOptions: DataTableOptions = {
      i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
      elevation: 0,
      download: false,
      print: false,
      selectableRows: false,
      canEdit: false,
      canDelete: false,
      // canInsert: hasPermission(Resources.Trades, [UserPermission.EDIT]),
      customInsertEditModal: hasPermission(Resources.Trades, [UserPermission.EDIT]),
      onRowInsert: async () => {
        setShowAddPosition(true)
        return true
      },
      rowCustomActions: getTableActions()
    }

    /* Código de Posición
    Tipo de Operación
    Elemento Logistico */

    const columns: DataTableColumn[] = [
      {
        name: 'codPosicion',
        label: t('trades:forms.add.sections.positions.tableColumns.positionCode'),
        type: DataType.TEXT
      },
      {
        name: 'tipoPosicion',
        label: t('trades:forms.add.sections.positions.tableColumns.operationType'),
        type: DataType.TEXT
      },
      {
        name: 'puntoEntrega.descripcion',
        label: t('trades:forms.add.sections.positions.tableColumns.logicEl'),
        type: DataType.TEXT
      }
    ]

    return (
      <Grid container>
        <CustomFormDialog {...formProps}></CustomFormDialog>
        <Grid item xs={12}>
          <DataTable
            data={tableData}
            columns={columns}
            options={tableOptions}
            userPermissions={getUserPermissions(Pages.Trades)}
          />
        </Grid>
      </Grid>
    )
  }
)
